import React, { useEffect, useState } from "react";

/***
 * A source component that returns the width of the window.
 * 
 * Params:
 *      none
 */
export const WindowWidth = React.memo(function WindowWidth(): React.ReactElement {
    const [width, setWidth] = useState(window.innerWidth);
    useEffect(() => {
        const handleResize = () => {
            setWidth(window.innerWidth);
        };
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);
    return <>{width}</>;
});